import { render, staticRenderFns } from "./ButtonsBlock.vue?vue&type=template&id=90cec812&"
import script from "./ButtonsBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonsBlock.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports